import { render } from "./BaseDropMenu.vue?vue&type=template&id=cb373fd0"
import script from "./BaseDropMenu.vue?vue&type=script&lang=js"
export * from "./BaseDropMenu.vue?vue&type=script&lang=js"
script.render = render

export default script